<template>
  <div class='welcome' >
    <!-- <div class="banner">
        <div class="title">
          <span></span>
          <div class="opt">
            <span class="date">更新时间：{{ createDate }}</span>
            <span class="opt-btn" @click="refresh">点击刷新</span>
          </div>
        </div>
        <div class="wel-banner">{{ showUserInfo }}</div>
        <h3 class="h3">欢迎登录驾驶舱</h3>
    </div> -->
    <div class="welcome-container" v-loading="loading">
  
        <permission class="wel-row wel-power-container" code="320001,220001,12010001">
          <div class="wel-waybill">
            <div class="waybill-title">
              <h4 class="h4"> {{ showUserInfo }},欢迎登录驾驶舱  运力看板</h4>
            
              <div class="waybill-title-expand">
                <span class="date">时间：</span>
                <el-date-picker
                v-model="time1"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions">
              </el-date-picker>
              </div>
            </div>
            <div class="wel-row wel-power-content">
              <div class="wel-power-item" >
                <div class="wel-add">
                  <div class="tip">司机新增</div>
                  <div class="size" @click="toDriver">{{driverCount}}</div>
                </div>
                <div class="wel-add">
                  <img src="https://hyzg-app.oss-cn-beijing.aliyuncs.com/power-up.png" class="power-up" />
                  <div   @click="dialogVisibleBun(1,'司机')" class="to">查看趋势图</div>
                </div>
              </div>
              <div class="wel-power-item">
                <div class="wel-add">
                  <div class="tip">车辆新增</div>
                  <div class="size"  @click="toVehicle" >{{vehicleCount}}</div>
                </div>
                <div class="wel-add">
                  <img src="https://hyzg-app.oss-cn-beijing.aliyuncs.com/power-up.png" class="power-up" />
                  <div  @click="dialogVisibleBun(2,'车辆')" class="to">查看趋势图</div>
                </div>
              </div>
              <div class="wel-power-item"  v-if="userType != 3">
                <div class="wel-add">
                  <div class="tip">托运人新增</div>
                  <div class="size" @click="toSender">{{shipperCount}}</div>
                </div>
                <div class="wel-add">
                  <img src="https://hyzg-app.oss-cn-beijing.aliyuncs.com/power-up.png" class="power-up" />
                  <div @click="dialogVisibleBun(3,'托运人')"  class="to">查看趋势图</div>
                </div>
              </div>
            </div>
          </div>
        </permission>
        <div class="wel-row wel-container">
          <permission class="wel-waybill" code="220002,320002,12010002" style="width: 350px;">
            <div class="waybill-title" style="display: contents;">
              <h4 class="h4" style="margin: 5px 0 0 21px;">运单数看板</h4>
              <div class="waybill-title-expand" style="  margin-bottom: 10px;">
                <span class="date">时间：</span>
                <el-date-picker
                style="width: 245px;"
                v-model="time2"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions">
              </el-date-picker>            
              </div>
            </div>
  
            <div class="waybill-content" style="padding-bottom: 15px;margin:0 21px 20px;">
              <div class="waybill-item">
                <span class="wel-total">运单数（累计）</span>
                <span class="wel-num size-blue" @click="toWaybill">{{ taskCount || 0 }}</span>
              </div>
              <div class="wel-add">
                  <img src="https://hyzg-app.oss-cn-beijing.aliyuncs.com/power-up.png" class="power-up yundan-pup" />
                  <div @click="dialogVisibleBun(4,'运单')"  class="toLink">查看趋势图</div>
                </div>
            </div>
          </permission>
          <permission class="wel-waybill wel-flex-3" code="220003,320003,12010003" style="height: 200px;">
            <div class="waybill-title">
              <h4 class="h4">运单状态看板（实时值）</h4>
            </div>
            <div class="wel-row">
              <div class="wel-col wel-item" style="height:120px" v-for="(item, index) in dataAnalysisTaskStatusVos" :key="index">
                <div class="wel-column">
                  <div v-if="item.taskStatus == 1" class="unit">计划</div>
                  <div v-if="item.taskStatus == 2" class="unit">在途</div>
                  <div v-if="item.taskStatus == 3" class="unit">到达</div>
                  <div class="num" @click="toWaybillEa(item.taskStatus)">{{item.taskCount}}</div>
                </div>
              </div>
              <div class="wel-col wel-item" style="height:120px"  @click="toFaue">
                <div class="wel-column flex-1">
                  <div class="wel-row-inner">
                    <div class="unit unit-column">
                      <div>未支付(司机结算)</div>
                     
                    </div>
                  </div>
                  <div class="wel-row-inner">
                    <div class="num">{{noPayCount}}</div>
                    <!-- <div class="toRouter">点击跳转</div> -->
                  </div>
                </div>
               
              </div>
  
              <div class="wel-col wel-item" style="height:120px"  @click="toFaue2">
                <div class="wel-column flex-1">
                  <div class="wel-row-inner">
                    <div class="unit unit-column">
                      <div>未支付(司机结算2.0)</div>
                    </div>
                  </div>
                  <div class="wel-row-inner">
                    <div class="num">{{noPayCount2}}</div>
                    <!-- <div class="toRouter">点击跳转</div> -->
                  </div>
                 
                 
                </div>
               
              </div>
  
            </div>
          </permission>
        </div>
        <div class="wel-row wel-content mt-15">
       
          <permission class="wel-waybill wel-flex-3 wel-cargo" code="220006,320006,12010006">
            <div class="waybill-title way-2">
              <h4 class="h4">货源看板（实时值）</h4>
              <div class="waybill-title-expand">
                <span class="date">时间：</span>
                <el-date-picker
                v-model="time4"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions">
              </el-date-picker>
              </div>
            </div>
            <div class="wel-row-2">
              <div class="wel-list-item">
                  <div class="sub">总货源</div>
                  <div class="hy-flex">
                    <div class="wel-unit">
                      <span class="price size-blue" @click="toDeliverList">{{ cargostart }}</span>
                      <span class="unit">次</span>
                    </div>
                    <div class="wel-add wel-add-pos">
                      <img src="https://hyzg-app.oss-cn-beijing.aliyuncs.com/power-up.png" class="power-up" />
                      <div @click="dialogVisibleBun(5,'货源')"  class="toLink">查看趋势图</div>
                    </div>
                    
                  </div>
                
                </div>
                <div class="wel-list-item"  style="margin-left:20px;">
                  <div class="sub">未发布</div>
                  <div class="wel-unit">
                    <span class="price size-blue" @click="toDeliverListEa(0)">{{ cargostart0 }}</span>
                    <span class="unit">次</span>
                  </div>
                </div>
                <div class="wel-list-item"  style="margin-left:20px;">
                  <div class="sub">已发布</div>
                  <div class="wel-unit">
                    <span class="price size-blue" @click="toDeliverListEa(1)">{{ cargostart1 }}</span>
                    <span class="unit">次</span>
                  </div>
                </div>
                <div class="wel-list-item"  style="margin-left:20px;">
                  <div class="sub">已关闭</div>
                  <div class="wel-unit">
                    <span class="price size-blue" @click="toDeliverListEa(2)">{{ cargostart2 }}</span>
                    <span class="unit">次</span>
                  </div>
                </div>
  
            </div>
          </permission>
          <!-- <permission class="wel-flex-1" code="220005,320005,12010005">
            <div class="flex-item" v-if="userType == 3">
              <div class="flex-conte">
                <div class="ti">账户余额</div>
                <div class="f-item">
                  <span class="price FI">{{balanceAmount}}</span>
                  <span class="unit">元</span>
                </div>
              </div>
              <img src="https://hyzg-app.oss-cn-beijing.aliyuncs.com/wel-flex-1.png" class="wel-flex-img-1" />
            </div>
            <div class="flex-item">
              <div class="flex-conte">
                <div class="ti">累计开票金额</div>
                <div class="f-item">
                  <span class="price">{{sumInvoiceAmountTax}}</span>
                  <span class="unit">元</span>
                </div>
              </div>
              <img src="https://hyzg-app.oss-cn-beijing.aliyuncs.com/wel-flex-2.png" class="wel-flex-img-2" />
            </div>
          </permission> -->
        </div>
        <permission class="wel-row wel-power-container" code="220004,320004,12010004">
            <div class="wel-waybill">
            <div class="waybill-title way-2">
              <h4 class="h4">财务看板</h4>
              <div class="waybill-title-expand">
                <span class="date">时间：</span>
                <el-date-picker
                v-model="time3"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions">
              </el-date-picker>
              </div>
            </div>
            <div class="wel-list">
              <div style="flex: 1;display: flex;flex-direction: row">
                <div class="wel-list-item">
                  <div class="sub">支付含税</div>
                  <div class="wel-unit">
                    <span class="price">{{ payAmountTax }}</span>
                    <span class="unit">元</span>
                  </div>
                </div>
                <div class="wel-list-item">
                  <div class="sub">开票金额</div>
                  <div class="wel-unit">
                    <span class="price">{{ invoiceAmountTax }}</span>
                    <span class="unit">元</span>
                  </div>
                </div>
              </div>
              <permission code="220005,320005,12010005" style="flex:1;display: flex;flex-direction: row">
                <div class="wel-list-item"  v-if="userType == 3" style="margin-left:20px;">
                  <div class="sub">账户余额</div>
                  <div class="wel-unit">
                    <span class="price FI">{{ balanceAmount }}</span>
                    <span class="unit">元</span>
                  </div>
                </div>
                <div class="wel-list-item"  :style="{ 'margin-left': userType == 3 ? '0' : '20px'}">
                  <div class="sub">累计开票金额</div>
                  <div class="wel-unit">
                    <span class="price">{{ sumInvoiceAmountTax }}</span>
                    <span class="unit">元</span>
                  </div>
                </div>
            </permission>
            </div>
          </div>
          </permission>
          <br/>  
     
    </div>
    <div class="opt">
              <span class="date">更新时间：{{ createDate }}</span>
              <span class="opt-btn" @click="clickRefresh">点击刷新</span>
            </div>
    <div class="welcomeBottom">
    
      <div class="wel-btn" href="https://hhy.cargocn.com/download/hhypdf/hhy-0825.pdf" target="_blank" @click="goVersion">
        点我查看更新文档
        <div class="dotted"></div>
      </div>
      <span>版本号：hhy20250328</span>
    </div>
  
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose">
  
      <div class="showdata_cen">
        <div class="showdata_tit">
            <h2>{{dialogEcharsTit}}</h2>
            <div class="date">
              <span class="date">时间跨度：</span>
              <el-select v-model="valuedigo"  @change="dialogecharssel" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
        </div>
        <div class="showdata_box"> 
          <div class="echart" id="mychart" :style="myChartStyle"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  </template>
  
  
  <script>
  import router from "../router";
  import store from "../store";
  import { post } from "../api/ajax";
  import permission from '../components/common/permission.vue';
  import {formatDateTime} from "../utils/utils";
  import * as echarts from "echarts";
  
  export default {
  components: { permission },
  name:"welcome",
  
  data() {
  return {
    driverCount: "-",
    shipperCount: "-",
    vehicleCount: "-",
    cargostart: "-",
    cargostart0: "-",
    cargostart1: "-",
    cargostart2: "-",
    loading: false,
    noPayCount: "-",
    noPayCount2: "-",
    dataAnalysisTaskStatusVos: [
      {
        taskStatus: 1,
        taskCount: "-"
      },
      {
        taskStatus: 2,
        taskCount: "-"
      },
      {
        taskStatus: 3,
        taskCount: "-"
      }
    ],
    createDate: 0,
    taskCount: "-",
    payAmountTax: "-",
    invoiceAmountTax: "-",
    balanceAmount: "-",
    sumInvoiceAmountTax: "-",
    type0: "3",
    type1: "3",
    type2: "3",
    type3: "3",
    dateOptions: [
      {
        value: '1',
        label: '今天'
      },     
      {
        value: '2',
        label: '近一周'
      }, {
        value: '3',
        label: '近一月'
      }, {
        value: '4',
        label: '近一季度'
      },
      {
        value: '5',
        label: '近一年'
      }
    ],
    imageList: [],
    dialogImageUrl: "",
    dialogVisible: false,
    time1:'',
    time2:'',
    time3:'',
    time4:'',
    pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            // start.setTime(start.getTime());
            start.setHours(0, 0, 0, 0);
            // 设置end为当天的23点59分59秒
            end.setHours(23, 59, 59, 999);
            picker.$emit('pick', [start, end]);
          }},
          {
          text: '本周',
          onClick(picker) {
            const currentDate = new Date();
            const currentDay = currentDate.getDay();
            const daysToMonday = (currentDay + 6) % 7;
            const mondayDate = new Date(currentDate);
            mondayDate.setDate(currentDate.getDate() - daysToMonday);
            // 创建一个日期范围对象，包括本周一到当前日期
            const startDate = new Date(mondayDate);
            const endDate = new Date(currentDate);
            // 设置start为当天的0点
            startDate.setHours(0, 0, 0, 0);
            // 设置end为当天的23点59分59秒
            endDate.setHours(23, 59, 59, 999);
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '本月',
          onClick(picker) {
            const currentDate = new Date();
            const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            const startDate = firstDayOfMonth;
            const endDate = currentDate;
            // 设置start为当天的0点
             startDate.setHours(0, 0, 0, 0);
            // 设置end为当天的23点59分59秒
            endDate.setHours(23, 59, 59, 999);
            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '本季度',
          onClick(picker) {
            const currentDate = new Date();
            // 获取当前月份
            const currentMonth = currentDate.getMonth();
            // 计算当前季度的开始月份
            const quarterStartMonth = Math.floor(currentMonth / 3) * 3;
            // 获取当前季度的第一天
            const firstDayOfQuarter = new Date(currentDate.getFullYear(), quarterStartMonth, 1);
            // 创建一个日期范围对象，包括当前季度的第一天到今天
            const startDate = firstDayOfQuarter;
            const endDate = currentDate;
            // 设置start为当天的0点
             startDate.setHours(0, 0, 0, 0);
            // 设置end为当天的23点59分59秒
            endDate.setHours(23, 59, 59, 999);
            picker.$emit('pick', [startDate, endDate]);
          }
        }, {
          text: '本年度',
          onClick(picker) {
          const currentDate = new Date();
          // 获取当前年份
          const currentYear = currentDate.getFullYear();
          // 计算当前年份的第一天
          const firstDayOfYear = new Date(currentYear, 0, 1);
          // 创建一个日期范围对象，包括当前年份的第一天到今天
          const startDate = firstDayOfYear;
          const endDate = currentDate;
            picker.$emit('pick', [startDate, endDate]);
          }
        }]
        
      },
    value: "",
    dialogEcharsTit:'司机新增趋势图',
      url: ``,
      xData: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"], //横坐标
      yData: [], //数据
      myChartStyle: { float: "left", width: "100%", height: "400px" } ,//图表样式
      time1:'',
      options: [{
          value: 2,
          label: '本周内'
        }, {
          value: 3,
          label: '本月内'
        }, {
          value: 4,
          label: '本季度'
        }, {
          value: 5,
          label: '本年度'
        }],
        valuedigo: 2,
        //max值，用于渲染柱状折现
        cargoMax:50,
        cargoMax2:30,
        interval:5,
        interval2:10,
        getAnalysisIndex:1,
  
  };
  },
  created() {
  // 在页面加载时默认选择本月的日期范围
  const currentDate = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const startDate = firstDayOfMonth;
  const endDate = currentDate;
   // 设置start为当天的0点
   startDate.setHours(0, 0, 0, 0);
  // 设置end为当天的23点59分59秒
  endDate.setHours(23, 59, 59, 999);
  const intoverDate = this.$store.state.sharing.intoverDate;
  const intoverDate2 = this.$store.state.sharing.intoverListDate;
  const intoverDate3 = this.$store.state.sharing.intoverMonDate;
  const intoverDate4 = this.$store.state.sharing.intoverDeliverListDate;
  if (intoverDate && intoverDate.length == 2) {
    var start = new Date(intoverDate[0]);
    var end = new Date(intoverDate[1]);
    this.time1 = [start, end];
  } else {
    this.time1 = [startDate, endDate];
  }
  if (intoverDate2 && intoverDate2.length == 2) {
    var start = new Date(intoverDate2[0]);
    var end = new Date(intoverDate2[1]);
    this.time2 = [start, end];
  } else {
    this.time2 = [startDate, endDate];
  }
  if (intoverDate3 && intoverDate3.length == 2) {
    var start = new Date(intoverDate3[0]);
    var end = new Date(intoverDate3[1]);
    this.time3 = [start, end];
  } else {
    this.time3 = [startDate, endDate];
  }
  if (intoverDate4 && intoverDate4.length == 2) {
    var start = new Date(intoverDate4[0]);
    var end = new Date(intoverDate4[1]);
    this.time4 = [start, end];
  } else {
    this.time4 = [startDate, endDate];
  }
  },
  computed: {
  routes() {
    return this.$store.state.sharing.routes;
  },
  userType() {
    return this.$store.state.sharing.userInfo.userType
  },
  showUserInfo() {
    var userName = this.$store.state.sharing.userInfo.userName;
    var newDate = new Date().getTime();
    var year = new Date().getFullYear();
    var mounth = new Date().getMonth() + 1;
    var day = new Date().getDate();
    var time1 = year + '-' + mounth + '-' + day + ' ' + '11:59:59';
    var diff  = new Date(time1).getTime();
    var time2 = year + '-' + mounth + '-' + day + ' ' + '17:59:59';
    var diff2 = new Date(time2).getTime();
    if (newDate - diff < 0) {
      return userName + ',' + '早上好'
    } else if (newDate - diff > 0 &&  newDate - diff2 < 0) {
      return userName + ',' + '下午好'
    } else {
      return userName + ',' + '晚上好'
    }
  },
  },
  watch: {
  type0(newVal, oldVal) {
    if (newVal != oldVal) {
      this.financeCount()
    }
  },
  type2(newVal, oldVal) {
    if (newVal != oldVal) {
      this.getWayList()
    }
  },
  type1(newVal, oldVal) {
    if (newVal != oldVal) {
      this.getTransportCount()
    }
  },
  type3(newVal, oldVal) {
    if (newVal != oldVal) {
      this.getCargoCount()
    }
  },
  
  time1(newVal, oldVal){
    if (newVal != oldVal && oldVal) {
      this.$store.commit('setIntoverDate', [formatDateTime(newVal[0]),formatDateTime(newVal[1])]);
      this.getTransportCount(formatDateTime(newVal[0]),formatDateTime(newVal[1]))
    }
  },
  time2(newVal, oldVal){
    if (newVal != oldVal && oldVal) {
      this.$store.commit('setIntoverListDate', [formatDateTime(newVal[0]),formatDateTime(newVal[1])]);
      this.getWayList(formatDateTime(this.time2[0]),formatDateTime(this.time2[1]))
    }
  },
  time3(newVal, oldVal){
    if (newVal != oldVal && oldVal) {
      this.$store.commit('setIntoverMonDate', [formatDateTime(newVal[0]),formatDateTime(newVal[1])]);
      this.financeCount(formatDateTime(this.time3[0]),formatDateTime(this.time3[1]))
    }
  },
  time4(newVal, oldVal){
    if (newVal != oldVal && oldVal) {
      this.$store.commit('setIntoverDeliverListDate', [formatDateTime(newVal[0]),formatDateTime(newVal[1])]);
      this.getCargoCount(formatDateTime(this.time4[0]),formatDateTime(this.time4[1]))
    }
  }
  },
  
  mounted() {
  // this.url=`https://hhy.cargocn.com/download/hhypdf/hhy-0415.pdf`;
  this.refresh();
  },
  async activated() {
    // await this.refresh();
  },
  methods: {
  goVersion(){
    var data = {
      name: '版本管理',
      path: '/version',
    }
    this.$root.$emit('routeEvent', data)
  },
  toDriver() {
    const startDate = formatDateTime(this.time1[0]);
    const endDate = formatDateTime(this.time1[1]);
    this.$store.commit('setIntoverDate', [startDate, endDate]);
    var data = {
      name: '司机管理',
      path: '/basicData/driverList'
    }
    this.$root.$emit('routeEvent', data)
    this.$router.push({ 
      path: '/basicData/driverList',
      query: {
        source: "welcome"
      }
    });
  
  },
  toVehicle() {
    const startDate = formatDateTime(this.time1[0]);
    const endDate = formatDateTime(this.time1[1]);
    this.$store.commit('setIntoverDate', [startDate, endDate]);
    var data = {
      name: '车辆管理',
      path: '/basicData/vehiclesList',
    }
    this.$root.$emit('routeEvent', data)
    this.$router.push({
      path: '/basicData/vehiclesList',
      query: {
        source: "welcome"
      }
    })
  },
  toSender() {
    const startDate = formatDateTime(this.time1[0]);
    const endDate = formatDateTime(this.time1[1]);
    this.$store.commit('setIntoverDate', [startDate, endDate]);
    var data = {
      name: '企业认证',
      path: '/basicData/companyCertify',
    }
    this.$root.$emit('routeEvent', data)
    this.$router.push({
      path: '/basicData/companyCertify',
      query: {
        source: "welcome"
      }
    })
  },
  toWaybill() {
    const startDate = formatDateTime(this.time2[0]);
    const endDate = formatDateTime(this.time2[1]);
    this.$store.commit('setIntoverListDate', [startDate, endDate]);
    var data = {
      name: '运单管理',
      path: '/businessm/Waybillm',
    }
    this.$root.$emit('routeEvent', data)
    this.$router.push({
      path: '/businessm/Waybillm',
      query: {
        source: "welcome"
      }
    })
  },
  toWaybillEa(status) {
    var data = {
      name: '运单管理',
      path: '/businessm/Waybillm',
    }
    this.$root.$emit('routeEvent', data)
    this.$router.push({
      path: '/businessm/Waybillm',
      query: {
        taskStatus: status,
        source: "welcome"
      }
    })
  },
  toDeliverList(){
    const startDate = formatDateTime(this.time4[0]);
    const endDate = formatDateTime(this.time4[1]);
    this.$store.commit('setIntoverDeliverListDate', [startDate, endDate]);
    var data = {
      name: '发货管理',
      path: '/businessm/deliverList',
    }
    this.$root.$emit('routeEvent', data)
    this.$router.push({
      path: '/businessm/deliverList',
      query: {
        source: "welcome"
      }
    })
  
  },
  toDeliverListEa(status){
    const startDate = formatDateTime(this.time4[0]);
    const endDate = formatDateTime(this.time4[1]);
    this.$store.commit('setIntoverDeliverListDate', [startDate, endDate]);
    var data = {
      name: '发货管理',
      path: '/businessm/deliverList',
    }
    this.$root.$emit('routeEvent', data)
    this.$router.push({
      path: '/businessm/deliverList',
      query: {
        taskStatus: status,
        source: "welcome"
      }
    })
  
  },
  async getWayList(startDt,endDt) {
    let that = this;
    if (!startDt) {
      const startDate = formatDateTime(this.time2[0]);
      const endDate = formatDateTime(this.time2[1]);
      startDt = startDate
      endDt = endDate
    }
    var res = await post("/api/dc/wh/data/analysis/taskCount", {
      // type: this.type2
      startDt:startDt,
      endDt:endDt
    })
    var dataAnalysisTaskStatusVos = res.dataAnalysisTaskStatusVos;
    if (dataAnalysisTaskStatusVos.length > 0) {
      var arr = [];
      var findIndex = dataAnalysisTaskStatusVos.findIndex(atem => {
        return atem.taskStatus == 1
      })
      if (findIndex > -1) {
        arr.push(dataAnalysisTaskStatusVos[findIndex])
      }
      var findIndex2 = dataAnalysisTaskStatusVos.findIndex(atem => {
        return atem.taskStatus == 2
      })
      if (findIndex2 > -1) {
        arr.push(dataAnalysisTaskStatusVos[findIndex2])
      }
      var findIndex3 = dataAnalysisTaskStatusVos.findIndex(atem => {
        return atem.taskStatus == 3
      })
      if (findIndex3 > -1) {
        arr.push(dataAnalysisTaskStatusVos[findIndex3])
      }
      that.dataAnalysisTaskStatusVos = arr;
    }
    that.noPayCount = res.noPayCount;
    that.noPayCount2 = res.noPayCount2;
    that.createDate = res.createDate;
    that.taskCount = res.taskCount;
    return res;
  },
  async financeCount(startDt,endDt) {
    let that = this;
    if (!startDt) {
      const startDate = formatDateTime(this.time3[0]);
      const endDate = formatDateTime(this.time3[1]);
      startDt = startDate
      endDt = endDate
    }
    var res = await post("/api/dc/wh/data/analysis/financeCount", {
      startDt:startDt,
      endDt:endDt
    })
    if (!res) return;
    console.log(res, "资金信息")
    that.payAmountTax = res.payAmountTax;
    that.sumInvoiceAmountTax = res.sumInvoiceAmountTax;
    that.createDate = res.createDate
    that.invoiceAmountTax = res.invoiceAmountTax;
    that.balanceAmount = res.balanceAmount;
    that.sumInvoiceAmountTax = res.sumInvoiceAmountTax;
    return res;
    
  },
  async getTransportCount(startDt,endDt) {//获取运力看板数据
    let that = this;
    if (!startDt) {
      const startDate = formatDateTime(this.time1[0]);
      const endDate = formatDateTime(this.time1[1]);
      startDt = startDate
      endDt = endDate
    }
    var res = await post("/api/dc/wh/data/analysis/transportCount", {
      // type: this.type1,
      startDt:startDt,
      endDt:endDt
    })
    console.log(res, "运力信息")
    that.vehicleCount = res.vehicleCount;
    that.driverCount = res.driverCount;
    that.shipperCount = res.shipperCount;
    return res;
  },
  async getCargoCount(startDt,endDt) {
    //获取货源看板数据
    let that = this;
    if (!startDt) {
      const startDate = formatDateTime(this.time4[0]);
      const endDate = formatDateTime(this.time4[1]);
      startDt = startDate
      endDt = endDate
    }
    var res = await post("/api/dc/wh/data/analysis/cargoCount", {
      // type: this.type1,
      startDt:startDt,
      endDt:endDt
    })
    console.log(res, "货源信息")
    that.cargostart = res.cargoCount;
    that.cargostart0 = res.dataAnalysisCargoStatusVos.filter(entry => entry.cargoStatus === 0).map(entry => entry.cargoCount)[0];
    that.cargostart1 = res.dataAnalysisCargoStatusVos.filter(entry => entry.cargoStatus === 1).map(entry => entry.cargoCount)[0];
    that.cargostart2 = res.dataAnalysisCargoStatusVos.filter(entry => entry.cargoStatus === 2).map(entry => entry.cargoCount)[0];
    return res;
  
  },
  async getAnalysis(index,type){
    let that = this;
    let res = await post("/api/dc/wh/data/analysis/trendAnalysis", {
      index: index,
      type:type,
    })
    const yDataArray = res.dataAnalysisTrendVo.map(item => item.number);
    const xDataArray = res.dataAnalysisTrendVo.map(item =>item.dimensionality);
    return [yDataArray,xDataArray]; 
    
  },
  initTime() {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const startDate = firstDayOfMonth;
    const endDate = currentDate;
    // 设置start为当天的0点
    startDate.setHours(0, 0, 0, 0);
    // 设置end为当天的23点59分59秒
    endDate.setHours(23, 59, 59, 999);
    const intoverDate = this.$store.state.sharing.intoverDate;
    const intoverDate2 = this.$store.state.sharing.intoverListDate;
    const intoverDate3 = this.$store.state.sharing.intoverMonDate;
    const intoverDate4 = this.$store.state.sharing.intoverDeliverListDate;
    if (!this.time1) {
      if (intoverDate && intoverDate.length == 2) {
        var start = new Date(intoverDate[0]);
        var end = new Date(intoverDate[1]);
        this.time1 = [start, end];
      } else {
        this.time1 = [startDate, endDate];
      }
    }
    
    if (!this.time2) {
      if (intoverDate2 && intoverDate2.length == 2) {
        var start = new Date(intoverDate2[0]);
        var end = new Date(intoverDate2[1]);
        this.time2 = [start, end];
      } else {
        this.time2 = [startDate, endDate];
      }
    }
 
    if (!this.time3) {
      if (intoverDate3 && intoverDate3.length == 2) {
        var start = new Date(intoverDate3[0]);
        var end = new Date(intoverDate3[1]);
        this.time3 = [start, end];
      } else {
        this.time3 = [startDate, endDate];
      }
    }
    if (!this.time4) {
      if (intoverDate4 && intoverDate4.length == 2) {
        var start = new Date(intoverDate4[0]);
        var end = new Date(intoverDate4[1]);
        this.time4 = [start, end];
      } else {
        this.time4 = [startDate, endDate];
      }
    }

  },
  async clickRefresh() {
    let that = this;
    that.loading = true;
    //初始化时间
    this.initTime();
    await this.refresh();
  },
  async refresh() {
    let that = this;
    try {
      var res = await that.financeCount();
      setTimeout(() => {
        that.loading = false;
      }, 500)
      var intoverListDate =  this.$store.state.sharing.intoverListDate;
      var result = {}
      if (intoverListDate) {
        result = await that.getWayList(intoverListDate[0], intoverListDate[1]);
      }
      var transportCount = await that.getTransportCount();
      var cargoCount =  await that.getCargoCount();
  
      var createDate = res.createDate;
      var createDate2 = result.createDate;
      var createDate3 = transportCount.createDate;
      var createDate4 = cargoCount.createDate;
  
  
      var str = createDate.replace(/-/g, '/');
      var str2 = createDate2.replace(/-/g, '/');
      var str3 = createDate3.replace(/-/g, '/');
      var str4 = createDate4.replace(/-/g, '/');
      var pares = new Date(str).getTime();
      var pares2 = new Date(str2).getTime();
      var pares3 = new Date(str3).getTime();
      var pares4 = new Date(str4).getTime();
      if (pares2 - pares > 0) {
        that.createDate = pares2 - pares3 > 0 ?  createDate2 : createDate3
      } else {
        that.createDate = pares - pares3 > 0 ? createDate : createDate3
      }
    } catch (error) {
      console.log(error)
      that.loading = false;
    }
  },
  toFaue() {
    //司机结算
    var routes = this.$store.state.sharing.routes;
    var userType = this.userType;
    var children = [];
    if (userType == 1) {
      var findIndex = routes.findIndex(atem => {
        return atem.name == '平台业务管理'
      })
      children = routes[findIndex].children;
    } else {
      children = routes;
    }
    var findIndex = children.findIndex(atem => {
      return atem.name == "结算支付"
    })
    if (findIndex < 0) return;
    var children1 = children[findIndex].children;
    var findIndex2 = children1.findIndex(atem => {
      return atem.name == "司机结算管理" || atem.name == "司机结算"
    })
    if (findIndex2 > -1) {
      //跳转司机结算
      var data = {
        name: children1[findIndex2].name,
        path: '/financialm/DirverSettlementm',
      }
      this.$root.$emit('routeEvent', data);
      this.$router.push({
        path: '/financialm/DirverSettlementm',
        query: {
          status: 2,
          source: "welcome"
        }
      })
  
    } else {
      this.$message.warning("未配置司机结算菜单");
    }
  },
  toFaue2() {
    //判断是否有司机结算2.0菜单权限
    var routes = this.$store.state.sharing.routes;
    var userType = this.userType;
    var children = [];
    if (userType == 1) {
      var findIndex = routes.findIndex(atem => {
        return atem.name == '平台业务管理'
      })
      children = routes[findIndex].children;
    } else {
      children = routes;
    }
    var findIndex = children.findIndex(atem => {
      return atem.name == "结算支付"
    })
    if (findIndex < 0) return;
    var children1 = children[findIndex].children;
    var findIndex2 = children1.findIndex(atem => {
      return atem.name == "司机结算2.0"
    })
    if (findIndex2 > -1) {
      //跳转司机结算2.0
      var data = {
        name: '司机结算2.0',
        path: '/financialm/DirverSettlementmTwo',
      }
      this.$root.$emit('routeEvent', data);
      this.$router.push({
        path: '/financialm/DirverSettlementmTwo',
        query: {
          status: 2,
          payStatus: 5,
          source: "welcome"
        }
      })
  
    } else {
      this.$message.warning("未配置司机结算2.0菜单");
    }
  },
  handleClose(done) {
    done();
    this.valuedigo = 2;
  },
  
  dialogVisibleBun(e,t){
    //趋势图点开初始化
    this.dialogVisible = true;
    this.dialogEcharsTit = t+'趋势图';
    this.valuedigo = 2;//每次点开默认本周内
    let stringName = '';
    if(e===1||e===3){
      stringName = '名'
    }else if(e===2){
      stringName = '辆'
    }else{
      stringName = '个'
    }
    //当前index
    this.getAnalysisIndex = e;
    //替换数据
   this.getAnalysis(e,2).then(result => {
    this.$nextTick(()=>{
       //输入5个值
        let cargoMax = this.findMaxAndCeil(result[0])
        let interval = this.returnInterval(cargoMax)
        this.initEcharts(result[0],result[1],cargoMax,interval,stringName);
      })
  })
  },
  dialogecharssel(val){
    console.log(val)
    //2：本周 3：本月 4：本季度 5：本年
    //趋势图筛选时间
    let max = this.findMaxAndCeil(this.yData);
    let stringName = '';
        this.cargoMax = max;
        this.cargoMax2 =  max;
        this.interval = this.returnInterval(this.cargoMax)
        this.interval2 = this.returnInterval(this.cargoMax);
        if(this.getAnalysisIndex===1||this.getAnalysisIndex===3){
          stringName = '名'
        }else if(this.getAnalysisIndex===2){
          stringName = '辆'
        }else{
          stringName = '个'
        }
        this.getAnalysis(this.getAnalysisIndex,val).then(result => {
          this.$nextTick(()=>{
            let cargoMax = this.findMaxAndCeil(result[0])
            let interval = this.returnInterval(cargoMax)
            this.initEcharts(result[0],result[1],cargoMax,interval,stringName);
            })
        })
  },
  initEcharts(eYdata,eXdata,cargoMax,interval,stringName) {
      // 基本柱状图
      const option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: '#007fcc'
                }
              }
            },
            color: [
                  '#1ebe38', '#007fcc'
               ],
            legend: {
              data: ["司机新增趋势图"],
              type: 'scroll',
              orient: 'vertical',
              right: 10,
              top: 20,
              bottom: 20,
  
            },
            legend: {
              data: ['折线图数值', '柱状图数值']
            },
            xAxis: [
              {
                type: 'category',
                data: eXdata,
                axisPointer: {
                  type: 'shadow'
                }
              }
            ],
            yAxis: [
              {
                type: 'value',
                name: '柱状图数值',
                min: 0,
                max: cargoMax,
                interval:interval,
                alignTicks: true,
                axisLabel: {
                  formatter: '{value}'+stringName
                },
                axisLine: {
                show: true,
                lineStyle: {
                  color: '#00bc4b'
                }
              },
              },
              {
                type: 'value',
                name: '折线图数值',
                min: 0,
                max: cargoMax,
                alignTicks: true,
                interval: interval,
                axisLabel: {
                  formatter: '{value}'+stringName
                },
                axisLine: {
                show: true,
                lineStyle: {
                  color: '#007fcc'
                }
              },
              }
            ],
            series: [
              {
                name: '柱状图数值',
                type: 'bar',
                tooltip: {
                  valueFormatter: function (value) {
                    return value ;
                  }
                },
                data:  eYdata
                
              },
              {
                name: '折线图数值',
                type: 'line',
                yAxisIndex: 1,
                data: eYdata
              }
            ]
          };
  
      const myChart = echarts.init(document.getElementById("mychart"));
      myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      //操作切换
      console.log(this.valuedigo)
  
  
   },
  findMaxAndCeil(array) {
    if (array.length === 0) {
      return null; // 如果数组为空，返回null或适当的默认值
    }
    var max = Math.max.apply(null, array);
    var maxCeil = Math.ceil(max / 10 )*10;
    return maxCeil;
  },
  returnInterval(maxValue){
    let baseInterval =0;
    if (0 <= maxValue && maxValue <= 30) {
    baseInterval = 5;
  }
  if (30 < maxValue && maxValue <= 50) {
    baseInterval = 10;
  }
  if (50 < maxValue && maxValue <= 200) {
    baseInterval = 20;
  }
  if (200 < maxValue && maxValue <= 500) {
    baseInterval = 50;
  }
  if (500 < maxValue && maxValue <= 1000) {
    baseInterval = 100;
  }
  if (1000 < maxValue && maxValue <= 2000) {
    baseInterval = 200;
  }
  if (2000 < maxValue && maxValue <= 5000) {
    baseInterval = 500;
  }
  if (5000 < maxValue && maxValue <= 10000) {
    baseInterval = 1000;
  }
  if (10000 < maxValue && maxValue <= 50000) {
    baseInterval = 10000;
  }
  if (50000 < maxValue && maxValue <= 100000) {
    baseInterval = 20000;
  }
  if (100000 < maxValue && maxValue <= 1000000) {
    baseInterval = 100000;
  }
    console.log(maxValue,baseInterval)
  
    return baseInterval;
  }
  }
  };
  </script>
  
  <style scoped lang="scss">
  /deep/ .fl {
  float: none !important;
  margin-left: 0 !important;
  }
  
  .page-content {
  overflow-x: hidden;
  }
  /deep/ .el-button--primary {
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
  }
  .wel-content {
  justify-content: space-between;
  align-items: center;
  margin: 0 36px;
  }
  .welcome1 {
  min-width: 1280px;
  box-sizing: border-box;
  }
  .power-up {
  width: 40px;
  height: 40px;
  }
  .wel-power-item {
  cursor: pointer;
  }
  
  .welcome {
  min-width: 1380px;
  box-sizing: border-box;
  background: #F6F6F6;
  overflow: hidden;
  padding-bottom: 70px;
  position: relative;
  .banner {
  width: 100%;
  height: 140px;
  background-image: url("https://hyzg-app.oss-cn-beijing.aliyuncs.com/wel-banner.gif");
  background-size: cover;
  background-color: #210453;
  .title {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 53px;
    font-size: 12px;
    padding: 0 32px;
    color: #FFFFFF;
  }
  
  .wel-banner {
    color: #FFFFFF;
    font-size: 18px;
    padding: 40px 0 12px 80px;
    line-height: 32px;
    box-sizing: border-box;
    position:relative;
    top:-25px;
  }
  .h3 {
    color: #FFFFFF;
    line-height: 32px;
    font-family: Alibaba PuHuiTi 2.0-85 Bold, Alibaba PuHuiTi 20;
    font-weight: normal;
    margin: 0 0 0 80px;
    font-size: 28px;
    position:relative;
    top:-34px;
  }
  
  }
  .wel-container-2 {
  width: 590px;
  height: 172px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #DBDBDB;
  margin-top: 15px;
  margin-right: 22px;
  overflow: hidden;
  }
  .wel-list {
  display: flex;
  flex-direction: row;
  padding: 0 21px 24px;
  .wel-list-item {
    flex: 1;
    height: 91px;
    background: #F4F7FA;
    border-radius: 8px 8px 8px 8px;
    padding: 20px 22px 18px;
    &:first-child {
      margin-right: 20px;
    }
    .sub {
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #001052;
      line-height: 13px;
      margin-bottom: 16px;
    }
    .wel-unit {
      vertical-align: baseline;
    }
    .price {
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #001052;
      line-height: 24px;
    }
    .unit {
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0,16,82,0.8);
      line-height: 13px;
      margin-left: 12px;
    }
  
  }
  }
  .wel-flex-1 {
  flex: 1;
  height: 172px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #DBDBDB;
  overflow: hidden;
  margin-top: 22px;
  padding: 57px 18px 24px;
  display: flex;
  .flex-item {
    width: 50%;
    height: 91px;
    background: #F4F7FA;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 21px;
    &:first-child {
      margin-right: 22px;
    }
    .ti {
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #001052;
      line-height: 13px;
      margin-bottom: 16px;
    }
    .price {
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #1890FF;
      line-height: 24px;
      margin-right: 12px;
      &.FI {
        color: #1890FF;
      }
    }
    .unit {
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0,16,82,0.8);
      line-height: 13px;
    }
  
  }
  }
  .wel-flex-img-1 {
  width: 62px;
  height: 62px;
  }
  .wel-flex-img-2 {
  width: 52px;
  height: 52px;
  }
  .wel-row {
  display: flex;
  flex-direction: row;
  } 
  .wel-container {
  margin: 15px 36px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  }
  
  
  .wel-btn {
  cursor: pointer;
  position: relative;
  width: 144px;
  height: 32px;
  background: #1890FF;
  border-radius: 2px 2px 2px 2px;
  text-align: center;
  color: #FFFFFF;
  font-size: 14px;
  line-height: 32px;
  cursor: pointer;
  margin-right: 16px;
  .dotted {
    position: absolute;
    right: -5px;
    top: -5px;
    width: 10px;
    height: 10px;
    background: #D93C3C;
    border-radius: 100%;
  }
  }
  
  
  .waybill-content {
  background: #F4F7FA;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  height: 110px;
  border-radius: 0px 0px 4px 4px;
  
  overflow: hidden;
  padding-bottom: 26px;
  .waybill-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .wel-total {
      color: #001052;
      font-size: 14px;
      padding-bottom: 12px;
      line-height: 18px;
      box-sizing: border-box;
    }
    .wel-num {
      font-size: 28px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #001052;
      line-height: 32px;
    }
  
  }
  .toLink {
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #1890FF;
    line-height: 12px;
    margin-left: 60px;
    cursor: pointer;
  }
  }
  .wel-waybill {
  width: 328px;
  margin-right: 15px;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  border: 1px solid #DFDFDF;
  &.wel-flex-3 {
    flex: 1;
    margin-right: 0;
    height: 160px;
    box-sizing: border-box;
    .wel-row {
      display: flex;
      flex-direction: row;
      padding: 0 16px;
      .wel-col {
        flex: 1;
        &.wel-item {
          margin: 0 12px;
          flex: 1;
          height: 85px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          background: #F4F7FA;
          .unit {
            font-size: 15px;
            color: #001052;
            line-height: 13px;
            text-align: center;
          }
          .num {
            font-size: 24px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #1890FF;
            line-height: 24px;
            margin-top: 20px;
            text-align: center;
            cursor: pointer;
          }
          .price {
            font-size: 24px;
            font-weight: 500;
            color: #001052;
            line-height: 24px;
          }
          .toRouter {
            font-size: 12px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #1890FF;
            line-height: 12px;
            cursor: pointer;
          }
  
        }
      }
    }
  
  }
  }  
  .waybill-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0 21px;
  box-sizing: border-box;
  background: #FFFFFF;
  &.way-2 {
    height: 57px;
  }
  .h4 {
    margin: 0;
    font-weight: 500;
    color: rgba(0,0,0,0.85);
    font-size: 16px;
  }
  .waybill-title-expand {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-left: 21px;
    .date {
      color: rgba(0,0,0,0.65);
      font-size: 14px;
    }
    .date-select {
      width: 89px;
    }
  
  }
  
  }
  .welcome-container {
  // margin-top: -72px;
  }
  .wel-power-container {
  margin: 15px 36px 0 !important;
  height: 160px;
  .wel-waybill {
    width: 100%;
    margin: 0;
  }
  .wel-power-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .wel-power-item {
      flex: 1;
      margin: 0 21px;
      height: 85px;
      background: #F4F7FA;
      border-radius: 8px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      .to {
        color: #1890FF;
        font-size: 12px;
        margin-top: 8px;
      }
      .wel-add {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .tip {
          color: #001052;
          font-size: 13px;
        }
        .size {
          font-weight: 500;
          color: #1890FF;
          font-size: 24px;
          margin-top: 8px;
        }
      }
    }
  }
  }
  }
  .linkTo {
  width: 80px;
  height: 30px;
  background: #5888c3;
  border-radius: 10px;
  text-align: center;
  margin-left: 10px;
  color: #fff;
  }
  .welcometit {
  font-size: 60px;
  font-weight: bold;
  margin-left: 10%;
  font-style: italic;
  margin-top: 260px;
  color: #0070b1;
  margin-bottom: 30px;
  }
  .welcomeimg {
  width: 45%;
  position: absolute;
  right: 3%;
  bottom: 23%;
  }
  .welcomeBottom {
  position: absolute;
  right: 80px;
  bottom: 10px;
  font-size: 16px;
  color: #aaaaaa;
  display: flex;
  align-items: center;
  flex-direction: row;
  }
  
  .edition {
  width: 144px;
  height: 44px;
  background: #0072AD;
  border-radius: 8px 8px 8px 8px;
  /* opacity: 1; */
  color: white;
  line-height: 44px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  }
  .badge{
  margin-top: 10px;
  margin-right: 40px;
  }
  .edition_box{
  margin-left: 10%;
  
  }
  .wel-cargo{
  position: relative;
  height: 170px;
  }
  
  .opt{
  text-align: right;
  margin-right: 80px;
  margin-top: 20px;
  font-size: 16px;
  }
  .opt-btn {
  display: inline-block;
    padding: 2px;
    border: 2px solid #007fcc;
    border-radius: 5px;
    font-size: 14px;
    margin-left: 20px;
    color: #007fcc;
    cursor: pointer;
    }
  .wel-row-2{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    padding: 0 21px;
    .wel-list-item{
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      height: 91px;
      background: #F4F7FA;
      border-radius: 8px 8px 8px 8px;
      padding: 20px 22px 18px;
      .sub{
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #001052;
        line-height: 13px;
        margin-bottom: 16px;
        
      }
      .wel-unit{
          vertical-align: baseline;
          .price{
            font-size: 20px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color:#001052;
            line-height: 24px;
  
          }
          .unit{
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0, 16, 82, 0.8);
            line-height: 13px;
            margin-left: 12px;
  
          }
  
        }
    }
  
  }
  
  .showdata_cen{
    width: 96%;
    border:1px solid #007fcc;
    border-radius: 10px;
    margin-left: 3%;
    padding: 20px;
    .showdata_tit{
      width: 100%;
      display: flex;
      h2{
        flex: 3;
      }
      .date{
        flex: 1;
        text-align: right;
      }
    }
    .showdata_box{
      width: 100%;
      display: flex;
      .echart{
        flex: 1;
      }
      
    }
    .echart_tit{
        width: 100%;
        height: 40px;
        display: flex;
        position: relative;
        top:-30px;
        h3{
          flex: 1;
          text-align: center;
        }
      }
  
  }
  .hy-flex{
    width:100%;
    display: flex;
  }
  .wel-add-pos{
    position: relative;
    top: -40px;
    left: 70px;
    .toLink{
      color: #007fcc;
      cursor: pointer;
    }
  }
  .yundan-pup{
    position: relative;
    left: 70px;
  }
  .size-blue{
    color: #1890FF !important;
      cursor: pointer;
  }
  .wel-row-inner {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    justify-content: center;
  }
  .flex-1 {
    flex: 1;
  }
  .unit-column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .mt-15 {
    margin-top: 15px;
  }
  </style>


// WEBPACK FOOTER //
// src/page/welcome.vue